// extracted by mini-css-extract-plugin
export default {"wrapper":"DetailsWrapper_wrapper__dcNTQ"};